export const styles = {
  textHead: {
    fontSize: '1rem'
  },
  icon: {
    width: '.7rem'
  },
  textField: {
    backgroundColor: 'white',
    width: '93%'
  },
  eachItem: {
    padding: '0'
  },
  dateShade: {
    backgroundColor: 'white',
    display: 'inline-block',
    padding: 0
  },
  selected: {
    control: (base) => ({
      ...base,
      height: '45px',
      width: '93%'
    })
  },
  input1: {
    height: '12px',
    width: '100%'
  },
  disp: {
    justifyContent: 'start',
    paddingLeft: '2px'
  },
  linrBreak: {
    marginTop: '40px'
  },
  margin: {
    margin: '6px'
  },
  paddingTop: {
    paddingTop: '7px'
  },
  iconColor: {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  unImpItem: {
    paddingLeft: '0.7rem'
  }
}
